module.exports = __webpack_public_path__ + "img/icon-gp-128x128-05-flag.4e12f6de.svg";